<template>
  <div>
    <ProviderSelection
            @providerSelected="providerSelected"
            @dateChanged="dateChanged"
            @onSearch="onSearch"
    />
    <Card size="small">

      <a-row type="flex" justify="space-between">
        <a-col :span="6" class="stage-group-col">
          <a-radio-group defaultValue="matched" size="small" buttonStyle="solid" @change="onStageSelected">
            <a-radio-button value="raw">raw</a-radio-button>
            <a-radio-button value="matched">matched</a-radio-button>
            <a-radio-button value="delta">delta</a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col :span="6">
          <a-tag>{{ collectionName }}</a-tag>
        </a-col>
        <a-col :span="6">
        </a-col>
      </a-row>

      <Card  size="small" title="first 100 entries">
        <a-list size="small" bordered :loading="isLoading" :pagination="pagination" :dataSource="results">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a :href="item.url ? item.url : item.linkWeb" target="_blank">{{item.title}}</a>
            <div v-if="!!item.tvdb">&nbsp;(Season: {{item.season}} Episode: {{item.episode}})</div>
            <div v-else-if="item.season && item.episode && item.season !== '0' && item.episode !== '0'">&nbsp;(Season: {{item.season}} Episode: {{item.episode}})</div>
            <div v-else-if="item.seasonNumber && item.episodeNumber && item.seasonNumber !== '0' && item.episodeNumber !== '0'">&nbsp;(Season: {{item.season}} Episode: {{item.episode}})</div>
            <div>&nbsp;(Start: {{moment(item.start).format('YYYY-MM-DD')}} End: {{moment(item.end).format('YYYY-MM-DD')}})</div>
          </a-list-item>
        </a-list>
      </Card>
    </Card>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment';
import { DatePicker, List, Button, Card, Row, Col, Radio, Input, Tag, Divider } from 'ant-design-vue'
import ProviderSelection from './ProviderSelection'

const PROVIDER_ID_MAP = {
  'raw': {
    'Amazon': 'amazon_offers',
    'Netflix': 'netflix_offers',
    'Maxdome': 'maxdome_raw',
    'Magenta TV': 'magenta_tv_raw',
    'Joyn': 'joyn_raw',
    'Sky Ticket': 'sky_ticket_raw',
    'TV NOW': 'tvnow_raw',
    'Disney+': 'disney_plus_raw',
    'Apple TV+': 'apple_tv_plus_raw',
    'iTunes Video': 'itunes_video_raw'
  },
  'matched': {
    'Amazon': 'amazon_offers_merged',
    'Netflix': 'netflix_offers_merged',
    'Maxdome': 'maxdome_offers',
    'Magenta TV': 'magenta_tv_offers',
    'Joyn': 'joyn_offers',
    'Sky Ticket': 'sky_ticket_offers',
    'TV NOW': 'tvnow_offers',
    'Disney+': 'disney_plus_offers',
    'Apple TV+': 'apple_tv_plus_offers',
    'iTunes Video': 'itunes_video_offers'
  },
  'delta': {
    'Amazon': 'amazon_offers_delta',
    'Netflix': 'netflix_offers_delta',
    'Maxdome': 'maxdome_offers_delta',
    'Magenta TV': 'magenta_tv_offers_delta',
    'Joyn': 'joyn_offers_delta',
    'Sky Ticket': 'sky_ticket_offers_delta',
    'TV NOW': 'tvnow_offers_delta',
    'Disney+': 'disney_plus_offers_delta',
    'Apple TV+': 'apple_tv_plus_offers_delta',
    'iTunes Video': 'itunes_video_offers_delta'
  }
}

export default {
  name: 'VodDataView',
  props: [],
  components: {
    ProviderSelection,
    DatePicker,
    List,
    Button,
    Card,
    Row,
    Col,
    Radio,
    Input,
    Tag,
    Divider
  },
  watch: {
    '$route': 'fetchData'
  },
  data () {
    return {
      selectedProvider: 'Amazon',
      selectedStage: 'matched',
      selectedDate: '2019_12_03',
      dateFormat: 'YYYY_MM_DD',
      collectionName: '',
      searchTerm: '',
      results: [],
      isLoading: false,
      currentItem: 'ASDF',
      pagination: {
        onChange: page => {
          console.log(page)
        },
        pageSize: 10,
        position: 'bottom',
        size: 'small',
        showQuickJumper: true
      },
      actions: [
        { type: 'star-o', text: '156' },
        { type: 'like-o', text: '156' },
        { type: 'message', text: '2' }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    moment,
    providerSelected (event) {
      console.log('selected', event)
      this.selectedProvider = event
      this.fetchData()
    },
    onStageSelected (event) {
      console.log('selected', event.target.value)
      this.selectedStage = event.target.value
      this.fetchData()
    },
    dateChanged (event) {
      console.log('selected', event)
      this.selectedDate = event // .split('T')[0]
      this.fetchData()
    },
    onSearch (event) {
      console.log('selected', event)
      this.searchTerm = event
      this.fetchData()
    },
    fetchData () {
      this.isLoading = true
      console.log('festching Data')

      const selectedProviderId = PROVIDER_ID_MAP[this.selectedStage][this.selectedProvider]
      this.collectionName = this.selectedDate + '-' + selectedProviderId

      axios.get('http://vod-qa-dashboard.mixd.tv:3000/vod-data/' +
      // axios.get('http://localhost:3000/vod-data/' +
              this.collectionName + '/?search=' + this.searchTerm
      )
        .then(response => {
          this.results = response.data.data
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>

  .date-picker {
    width: 110px;
    margin-top: -2px;
  }

  .date-picker + div + input {
    border-radius: 0px !important;
    border-left: 0px !important;
    border-right: 0px !important;
  }

  .stage-group-col {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/VodDataView.vue